
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Gone() {
  const location = useLocation();

  useEffect(() => {
    document.title = "410 Gone – This page has been permanently removed";

    const addMeta = (name: string, content: string) => {
      const existing = document.querySelector(`meta[name="${name}"]`);
      if (existing) {
        existing.setAttribute("content", content);
      } else {
        const meta = document.createElement("meta");
        meta.setAttribute("name", name);
        meta.setAttribute("content", content);
        document.head.appendChild(meta);
      }
    };

    addMeta("robots", "noindex, nofollow");
    addMeta("googlebot", "noindex, nofollow");

    return () => {
      document.querySelectorAll('meta[name="robots"], meta[name="googlebot"]').forEach((el) => {
        el.remove();
      });
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-white">
      <div className="relative z-10 max-w-lg">
        <p className="text-7xl font-black text-gray-100 select-none pointer-events-none absolute inset-0 flex items-center justify-center text-[10rem] leading-none">
          410
        </p>
        <div className="relative z-10">
          <h1 className="text-2xl font-semibold text-gray-800 mt-4">
            Page Permanently Removed
          </h1>
          <p className="mt-2 text-sm text-gray-400 font-mono break-all">
            {location.pathname}
          </p>
          <p className="mt-4 text-base text-gray-500">
            This page no longer exists and has been permanently removed.
          </p>
          <a
            href="/"
            className="inline-block mt-6 px-6 py-2 bg-gray-900 text-white text-sm rounded-md hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Go to Homepage
          </a>
        </div>
      </div>
    </div>
  );
}
